import { ChakraStylesConfig } from "chakra-react-select";
import { mergeWith } from "lodash-es";
import { chakraSimpleSelectStyles } from "shared/components/input/select/ChakraSimpleSelectStyles";
import { SelectOptionData } from "shared/components/input/select/SelectTypes";

export const dataTableSelectStyles: ChakraStylesConfig<SelectOptionData> = {
  ...chakraSimpleSelectStyles,
  container: (provided, state) =>
    mergeWith({}, chakraSimpleSelectStyles.container?.(provided, state), {
      minHeight: "unset",
    }),
  menu: (provided, state) =>
    mergeWith({}, chakraSimpleSelectStyles.menu?.(provided, state), {
      mt: "1px",
    }),
  menuList: (provided, state) =>
    mergeWith({}, chakraSimpleSelectStyles.menuList?.(provided, state), {
      borderRadius: 0,
    }),
  control: (provided, state) =>
    mergeWith({}, chakraSimpleSelectStyles.control?.(provided, state), {
      border: "none",
      borderRadius: 0,
      h: "100%",
    }),
  clearIndicator: (provided, state) =>
    mergeWith({}, chakraSimpleSelectStyles.clearIndicator?.(provided, state), {
      marginRight: "-13px",
      borderRadius: 0,
    }),
  dropdownIndicator: (provided, state) =>
    mergeWith(
      {},
      chakraSimpleSelectStyles.dropdownIndicator?.(provided, state),
      {
        marginRight: "-13px",
      },
    ),
};
